export interface ToastMessage extends AppMessage {
  id: string;
}

export interface AppMessage {
  level: (typeof messageLevels)[number];
  text: string;
  collapse_id?: string;
  action_url?: string;
  action_text?: string;
  // Click handler for an in-app action (e.g. "Undo") that can't be expressed
  // as a navigable action_url. When set, the toast renders action_text as a
  // button firing this instead of an anchor.
  on_action?: () => void;
  persistent?: boolean;
  expires_at?: string;
  open_in_new_tab?: boolean;
  // Absent on every notification sent before AP-8775, and on every generic
  // toast since. Absent means "render this as a toast".
  type?: AppMessageType;
}

export const messageLevels = ['info', 'success', 'warning', 'error'] as const;

export enum AppMessageType {
  MEMBER_JOINED = 'member_joined',
  MEMBER_JOINED_CLEARED = 'member_joined_cleared'
}

export interface MemberJoinedData {
  appointment_healthie_id: number | null;
  appointment_id: string;
  appointment_title: string | null;
  member_name: string | null;
  person_id: string | null;
  /** The appointment's calendar date in this counselor's timezone, e.g. "2026-09-23". */
  start_at_date: string;
  /** Already localized to this counselor's timezone by the backend, e.g. "4:00 PM". */
  start_at_display: string;
}

export interface MemberJoinedMessage extends ToastMessage {
  data: MemberJoinedData;
  type: AppMessageType.MEMBER_JOINED;
}

export interface MemberJoinedClearedMessage extends ToastMessage {
  data: Pick<MemberJoinedData, 'appointment_id'>;
  type: AppMessageType.MEMBER_JOINED_CLEARED;
}

export type IncomingAppMessage = MemberJoinedClearedMessage | MemberJoinedMessage | ToastMessage;
